// Function to convert time string to Date object
export const parseTimeString = (timeString: string): Date => {
  const timeRegex = /^([01]?[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/; // Regular expression for HH:MM:SS format

  if (!timeRegex.test(timeString)) {
    console.log('Invalid time format. Please use HH:MM:SS format.', timeString);
    return new Date(timeString);
  }

  const [hours, minutes, seconds] = timeString.split(':').map(Number);

  return new Date(0, 0, 0, hours, minutes, seconds);
};
